import React, { useEffect, useState } from "react";
import AppLayout from "../components/AppLayout";
import { api } from "../lib/api";
import { useI18n } from "../contexts/I18nContext";

export default function Notifications() {
  const { t } = useI18n();
  const [items, setItems] = useState([]);
  const fetchAll = () => api.get("/notifications").then((r) => setItems(r.data));
  useEffect(() => { fetchAll(); }, []);
  const mark = async (id) => { await api.post(`/notifications/${id}/read`); fetchAll(); };
  return (
    <AppLayout>
      <h1 className="font-heading text-3xl sm:text-4xl font-black">{t("notifications")}</h1>
      <div className="mt-8 space-y-3" data-testid="notifications-list">
        {items.map((n) => (
          <div key={n.id} data-testid={`notif-${n.id}`} className={`pp-card p-5 flex items-start gap-3 ${n.is_read ? "opacity-60" : ""}`}>
            <div className={`w-2 h-2 rounded-full mt-2 ${n.is_read ? "bg-zinc-600" : "bg-[#00E676]"}`} />
            <div className="flex-1">
              <div className="font-medium">{n.title}</div>
              <div className="text-sm text-zinc-400">{n.body}</div>
              <div className="text-xs text-zinc-500 mt-1">{new Date(n.created_at).toLocaleString()}</div>
            </div>
            {!n.is_read && <button onClick={() => mark(n.id)} className="text-xs text-[#00E676] hover:underline">Mark read</button>}
          </div>
        ))}
        {items.length === 0 && <div className="pp-card p-10 text-center text-zinc-500" data-testid="notif-empty">{t("no_results")}</div>}
      </div>
    </AppLayout>
  );
}
